import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { BillingRouteErrorBoundary } from "@/app/billing/components/billing-route-error-boundary";
import { BillingOverviewSkeleton } from "@/app/billing/overview/components/billing-overview-skeleton";
import { BillingOverviewPage } from "@/app/billing/overview/overview";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/billing/overview"
)({
  component: () => (
    <Suspense fallback={<BillingOverviewSkeleton />}>
      <BillingOverviewPage />
    </Suspense>
  ),
  errorComponent: BillingRouteErrorBoundary,
  loader: () => ({
    crumb: "Overview",
  }),
});
